import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' }
});

// Request interceptor — attach access token
api.interceptors.request.use((config) => {
  // Get token from Zustand persisted store
  try {
    const stored = JSON.parse(localStorage.getItem('findr-auth') || '{}');
    const token = stored.state?.accessToken;
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch {}
  return config;
});

// Response interceptor — handle 401 and refresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const stored = JSON.parse(localStorage.getItem('findr-auth') || '{}');
        const refreshToken = stored.state?.refreshToken;
        if (!refreshToken) throw new Error('No refresh token');
        const baseURL = process.env.REACT_APP_API_URL || '/api';
        const { data } = await axios.post(`${baseURL}/auth/refresh`, { refreshToken });
        // Update stored tokens
        const current = JSON.parse(localStorage.getItem('findr-auth') || '{}');
        if (current.state) {
          current.state.accessToken = data.accessToken;
          current.state.refreshToken = data.refreshToken;
          localStorage.setItem('findr-auth', JSON.stringify(current));
        }
        original.headers.Authorization = `Bearer ${data.accessToken}`;
        return api(original);
      } catch {
        localStorage.removeItem('findr-auth');
        window.location.href = '/auth';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
